<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        persistent
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Edit {{ data && data.RATE_TYPE === 'PACKAGE' ? 'Package' : 'Diagnostic' }}: &nbsp;<v-chip>{{ data && data.DIA_T ? data.DIA_T : '' }}</v-chip>
                </v-card-title>
                <v-card-text>
                    <v-combobox
                        v-if="data"
                        v-model="editData.DIA_T"
                        :label="data.RATE_TYPE === 'PACKAGE' ? 'Package Name' : 'Diagnostic Name'"
                        color="teal"
                        :items="getAcuDiagnosticSuggestions && Array.isArray(getAcuDiagnosticSuggestions.data) ? getAcuDiagnosticSuggestions.data.filter(aItem => !rateItems.some(bItem => bItem.DIA_T.includes(aItem))) : []"
                        :rules="[v => v !== '' && v !== null && v !== undefined && /[a-zA-Z]/.test(v) || 'This field is required']"
                        clearable
                        @update:search-input="searchText"
                    />
                    <v-checkbox
                        v-model="editData.USE_HMI_RATE"
                        label="Use HMI Rate"
                        style="padding: 20px 0; margin: 0;"
                        color="teal"
                        hide-details
                    />
                    <v-text-field
                        ref="editratephp"
                        v-model="editData.PHP_N"
                        :disabled="editData.USE_HMI_RATE"
                        label="Price"
                        color="teal"
                        :rules=" editData.USE_HMI_RATE ? [()=>true] : requiredField.concat(isValidPHPN)"
                        clearable
                    />
                    <v-text-field
                        ref="editrateminage"
                        v-model="editData.MIN_AGE"
                        label="Min. Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => v <= editData.MAX_AGE || 'Must be less than or equal to Max Age'
                        ]"
                    />
                    <v-text-field
                        ref="editratemaxage"
                        v-model="editData.MAX_AGE"
                        label="Max. Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => Number(v) >= Number(editData.MIN_AGE) || 'Must be greater than or equal to Min Age'
                        ]"
                        hint="120 represents no upper age limit."
                    />
                    <v-checkbox
                        v-model="editData.HIDE_AGE_RESTRICTION"
                        label="Hide Age Restriction"
                        style="padding: 20px 0; margin: 0;"
                        color="teal"
                        hide-details
                    />
                    <v-text-field
                        ref="editrateannotation"
                        v-model="editData.ANNOTATION"
                        label="Annotation"
                        color="teal"
                        clearable
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'
export default {
    props: ['show', 'data', 'rateItems'],
    data: ()=>({
        mdiCheck,
        mdiClose,
        diagnostics: ['Chest X-ray', 'Complete Blood Count (CBC)', 'Electrocardiogram (ECG)', 'Pap Smear', 'Physical Examination', 'Routine Fecalysis', 'Routine Urinalysis', 'Taking of Medical History'],
        editData: {
            ID: null,
            MSU_C: null,
            DIA_T: null,
            PHP_N: null,
            USE_HMI_RATE: null,
            TYPE_T: null,
            MIN_AGE: null,
            MAX_AGE: null,
            HIDE_AGE_RESTRICTION: null,
            ANNOTATION: null
        },
        isValidPHPN: value => {
            if (value === '' || value === null) return true
            const regex = /^(0|[1-9]\d*)(\.\d+)?$/
            return regex.test(value) || 'Enter a non-negative number'
        },
        requiredField: [v=>!!v||'This field is required']
    }),
    computed: {
        ...mapGetters(['getAcuDiagnosticSuggestions']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.resetValidation()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        data(newVal) {
            this.editData = structuredClone(newVal)
        },
        'editData.USE_HMI_RATE' (newVal) {
            if (newVal) {
                this.editData.PHP_N = 0
                this.$nextTick(() => {
                    if (this.$refs) {
                        if (this.$refs['editratephp']) this.$refs['editratephp'].validate()
                    }
                })
            }
        },
        'editData.MIN_AGE' () {
            this.$nextTick(() => {
                if (this.$refs) {
                    if (this.$refs['editratemaxage']) this.$refs['editratemaxage'].validate()
                    if (this.$refs['editrateminage']) this.$refs['editrateminage'].validate()
                }
            })
        },
        'editDate.MAX_AGE' () {
            this.$nextTick(() => {
                if (this.$refs) {
                    if (this.$refs['editratemaxage']) this.$refs['editratemaxage'].validate()
                    if (this.$refs['editrateminage']) this.$refs['editrateminage'].validate()
                }
            })
        }
    },
    methods: {
        ...mapActions(['editMsuRates', 'suggestAcuDiagnostics']),
        editMaxAge(age) {
            if (age === 120) {
                this.editData.MAX_AGE = 120
            }
            this.isMaxAgeEditable = !this.isMaxAgeEditable
        },
        searchText(value) {
            this.editData.DIA_T = value
        },
        submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.editMsuRates(this.editData).then(() => this.suggestAcuDiagnostics())
            }
        },
        resetValidation() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
                this.editData = structuredClone(this.data)
            }
        }
    }
}
</script>
